import moment from 'moment';
import { commonDescendingComparator, momentDescendingComparator } from 'utils/helper';

export const COLUMNS = [
    {
        id: 'name',
        columnTitle: 'Name',
        comparator: (order, rubrics, _) => {
            if (!order) return rubrics;
            const getter = (r) => {
                return r.rubric.title.toLowerCase();
            };

            if (order === 'desc') {
                const sortedRubrics = [...rubrics].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedRubrics;
            }
            const sortedRubrics = [...rubrics].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedRubrics;
        },
    },
    {
        id: 'lastupdated',
        columnTitle: 'Last Updated',
        comparator: (order, rubrics, _) => {
            if (!order) return rubrics;
            const getter = (r) => {
                if (!r.modified_on) return null;
                return moment(r.modified_on);
            };

            if (order === 'desc') {
                const sortedRubrics = [...rubrics].sort((a, b) => momentDescendingComparator(a, b, getter));
                return sortedRubrics;
            }
            const sortedRubrics = [...rubrics].sort((a, b) => -momentDescendingComparator(a, b, getter));
            return sortedRubrics;
        },
    },
    {
        id: 'criteria',
        columnTitle: 'Criteria',
        comparator: (order, rubrics, _) => {
            if (!order) return rubrics;
            const getter = (r) => {
                return r.rubric.criteria.length;
            };

            if (order === 'desc') {
                const sortedRubrics = [...rubrics].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedRubrics;
            }
            const sortedRubrics = [...rubrics].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedRubrics;
        },
    },
    {
        id: 'points',
        columnTitle: 'Points',
        comparator: (order, rubrics, _) => {
            if (!order) return rubrics;
            const getter = (r) => {
                return r.rubric.criteria.reduce((acc, cur) => {
                    return acc + Math.max(...cur.options.map(({ rate }) => Number(rate)));
                }, 0);
            };

            if (order === 'desc') {
                const sortedRubrics = [...rubrics].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedRubrics;
            }
            const sortedRubrics = [...rubrics].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedRubrics;
        },
    },
];
